/* ============================================================
   DANCING DISC — PDP interactivity (2026)
   Loaded only on product pages (see layout/theme.liquid).
   Purely additive: reads the native variant radios that Horizon
   already wires to Shopify, and reflects the current size into
   (a) the dynamic callout and (b) a "· $price" suffix on the CTA.
   It never changes the variant, the form, or the cart — Horizon
   keeps full control of variant switching and add-to-cart.
   ============================================================ */
(function () {
  'use strict';

  var SELR = '.product-information .variant-option__button-label:has(.dd-size-card__selr)';

  function checkedCard() {
    return document.querySelector(SELR + ':has(input:checked)') ||
           document.querySelector(SELR + ' input:checked');
  }

  function sizeKey() {
    var input = document.querySelector(SELR + ' input:checked');
    if (!input) return null;
    var name = (input.value || input.getAttribute('aria-label') || '').toLowerCase();
    if (name.indexOf('30') > -1) return '30';
    if (name.indexOf('24') > -1) return '24';
    if (name.indexOf('16') > -1) return '16';
    return null;
  }

  function updateCallout() {
    var callout = document.querySelector('[data-dd-size-callout]');
    if (!callout) return;
    var key = sizeKey();
    if (!key) return;
    var txt = callout.getAttribute('data-dd-' + key);
    var target = callout.querySelector('[data-dd-callout-text]');
    if (txt && target && target.textContent.trim() !== txt.replace('&amp;', '&').trim()) {
      target.textContent = txt.replace('&amp;', '&');
    }
  }

  function currentPrice() {
    var input = document.querySelector(SELR + ' input:checked');
    if (!input) return '';
    var label = input.closest('.variant-option__button-label');
    var priceEl = label && label.querySelector('.dd-size-card__price');
    return priceEl ? priceEl.textContent.trim() : '';
  }

  function updateCta() {
    var price = currentPrice();
    if (!price) return;
    var contents = document.querySelectorAll('.product-information .add-to-cart-text__content');
    contents.forEach(function (content) {
      var suffix = content.querySelector('.dd-cta-price');
      var want = ' · ' + price;
      if (!suffix) {
        suffix = document.createElement('span');
        suffix.className = 'dd-cta-price';
        content.appendChild(suffix);
      }
      if (suffix.textContent !== want) suffix.textContent = want;
    });
  }

  /* Move the real-customer avatar cluster next to the Loox star rating,
     mirroring the home hero's social proof. Runs once. */
  function placeAvatars() {
    var tpl = document.getElementById('dd-pdp-avatars');
    var rating = document.querySelector('.product-information .loox-rating');
    if (!tpl || !rating) return;
    if (document.querySelector('.product-information .dd-pdp-avatars')) return;
    var host = rating.closest('.shopify-block') || rating.parentElement;
    if (!host) return;
    host.classList.add('dd-rating-row');
    host.insertBefore(tpl.content.cloneNode(true), host.firstChild);
  }

  /* Show availability on the same line as the price to save a row. Rather
     than move Horizon's inventory element (which its variant re-render
     destroys), we MIRROR its text into our own chip inside .price__regular
     and hide the native one. Mirroring (instead of recomputing) keeps the
     low-stock urgency message and is always exactly as accurate as Horizon.
     Disc-only: without the DD size cards or without the native inventory
     block, the chip is removed and the native element is left untouched. */
  function renderStock() {
    var pi = document.querySelector('.product-information');
    if (!pi) return;
    var priceReg = pi.querySelector('.price__regular');
    var native = pi.querySelector('.product-inventory__text');
    var isDisc = !!pi.querySelector('.dd-size-card__selr');
    var chip = pi.querySelector('.price__regular .dd-instock');
    var label = native ? native.textContent.trim() : '';
    if (!isDisc || !priceReg || !label) {
      if (chip && chip.parentNode) chip.parentNode.removeChild(chip);
      pi.classList.remove('dd-has-inline-stock');
      return;
    }
    var state = 'in';
    if (pi.querySelector('.product-inventory__icon-low')) state = 'low';
    if (pi.querySelector('.product-inventory__icon-out_of_stock')) state = 'out';
    if (!chip) {
      chip = document.createElement('span');
      chip.className = 'dd-instock';
      priceReg.appendChild(chip);
    }
    chip.setAttribute('data-state', state);
    if (chip.textContent !== label) chip.textContent = label;
    pi.classList.add('dd-has-inline-stock');
  }

  /* Cause editions — mirror the selected size's donation into the price
     lockup (snippets/dd-give-price.liquid, rendered by blocks/price.liquid;
     [data-dd-give-strip] carries data-dd-give-30/24/16 from the variants),
     the hidden "Gives" line-item property, and the current row of the "what
     every disc gives" ladder. Horizon re-renders the block on variant change
     too; this keeps the number instant. No-op on the core disc. */
  function updateGive() {
    var key = sizeKey();
    if (!key) return;
    document.querySelectorAll('[data-dd-give-strip]').forEach(function (strip) {
      var amt = strip.getAttribute('data-dd-give-' + key);
      if (!amt) return;
      strip.querySelectorAll('[data-dd-give-amount]').forEach(function (target) {
        if (target.textContent !== amt) target.textContent = amt;
      });
    });
    /* The hidden line-item-property input in the product form (buy-buttons):
       its value follows the size so the cart/checkout line says the right amount. */
    document.querySelectorAll('[data-dd-give-prop]').forEach(function (inp) {
      var v = inp.getAttribute('data-dd-give-' + key);
      if (v && inp.value !== v) inp.value = v;
    });
    document.querySelectorAll('[data-dd-give-row]').forEach(function (row) {
      row.classList.toggle('is-current', row.getAttribute('data-dd-give-row') === key);
    });
  }

  function sync() {
    updateCallout();
    updateGive();
    updateCta();
    placeAvatars();
    renderStock();
  }

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.matches && t.matches('.variant-option__button-label input[type="radio"]')) {
      /* let Horizon's variant-selects update the DOM first */
      window.setTimeout(sync, 40);
      window.setTimeout(sync, 250);
    }
  });

  /* Horizon re-renders the buy box (price + add-to-cart) on variant change,
     which wipes the appended "· $price" span. A MutationObserver re-applies
     it after each re-render without ever touching Horizon's own markup. */
  function observe() {
    var root = document.querySelector('.product-information');
    if (!root || !window.MutationObserver) return;
    var raf = null;
    var mo = new MutationObserver(function () {
      if (raf) return;
      raf = window.requestAnimationFrame(function () { raf = null; sync(); });
    });
    mo.observe(root, { childList: true, subtree: true });
  }

  function init() { sync(); observe(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  window.setTimeout(sync, 400);
})();
